/**
 * Redux action type prefix for this project.
 * Please use this prefix for all actions.
 * e.g. INDOOR_MAP/sampleAction
 */
export const REDUX_ACTION_TYPE_PREFIX = "INDOOR_MAP"
